const moduleName = 'UI_ACTIONS';

const UI_ACTIONS = {
    TOGGLE_DRAWER: `${moduleName}_TOGGLE_DRAWER`
};
export default UI_ACTIONS;



// WEBPACK FOOTER //
// ./src/constants/actions/ui.js